export const WEBINAR_PLUS_DOMAIN = import.meta.env.VITE_WEBINAR_PLUS_DOMAIN;

export default function isCurrentlyOnWebinarPlusDomain() {
	return !!WEBINAR_PLUS_DOMAIN && window.location.hostname.endsWith(WEBINAR_PLUS_DOMAIN);
}
